import { gql } from '@apollo/client';

/**
 * Login mutation
 * Authenticates a user with username and password
 * Sets session cookie on success
 */
export const LOGIN_MUTATION = gql`
	mutation Login($username: String!, $password: String!) {
		login(username: $username, password: $password) {
			success
			error
			user {
				userId
				username
				email
				roles
				facilities {
					facilityId
					name
				}
			}
		}
	}
`;

/**
 * Logout mutation
 * Clears the user's session cookie
 */
export const LOGOUT_MUTATION = gql`
	mutation Logout {
		logout {
			success
			message
		}
	}
`;

/**
 * Current user query
 * Fetches the currently authenticated user from session
 */
export const CURRENT_USER_QUERY = gql`
	query CurrentUser {
		currentUser {
			isAuthenticated
			tokenExpiresAt
			user {
				userId
				username
				email
				roles
				facilities {
					facilityId
					name
				}
			}
		}
	}
`;
